import React from 'react';

const ReportContent = ({data, searchDetails, tableColumns}) => {

    const columns = [
        {id: "date_time", label: "Data/hora", render: element => element.date_time},
        {id: "entity_id", label: "Identificador", render: element => element.entity_id},
        {id: "loginuser", label: "Agente", render: element => element.loginuser},
        {id: "citysearch", label: "Município", render: element => element.citysearch},
        {id: "plate", label: "Placa", render: element => <span style={{fontWeight: 700}}>{element.plate}</span>},
        {id: "passages", label: "Passagens", render: element => element.passages},
        {id: "downloads", label: "Imagens", render: element => element.downloads},
        {id: "reason", label: "Motivo", render: element => element.reason},
    ];

    const visibleColumns = columns.filter(
        column => tableColumns?.[column.id]?.visible !== false,
    );

    const langLane = (lane) => {
        switch (lane) {
            case "ENTRANCE": return "ENTRADA";
            case "EXIT": return "SAÍDA";
            case "INTERNAL": return "INTERNO";
            case "MOBILE": return "FAIXA MÓVEL";
            default: return lane;
        }
    };

    const renderDownloads = (downloads = []) => {
        if (!searchDetails) return null;
        if (!downloads.length) return null;

        return (
            <table className="table-download w-full mt-2">
                <thead>
                    <tr className="text-left">
                        <th>Data/hora passagem</th>
                        <th>Município</th>
                        <th>Sentido</th>
                        <th>ID processamento</th>
                    </tr>
                </thead>

                <tbody>
                    { downloads.map((element, index) => (
                        <tr key={index} className={'download-content-table'}>
                            <td>{element.capture_time}</td>
                            <td>{element.cityName}</td>
                            <td>{langLane(element.laneDesc)}</td>
                            <td>{element.procid}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const renderDetails = (item) => {
        if (!searchDetails) return null;
        if (!item.citiesdata && (!item.listdownloads || !item.listdownloads.length)) return null;

        return (
            <tr className="search-details">
                <td colSpan={visibleColumns.length} className="px-[25px]">

                    <strong>Resultados de passagens:</strong>

                    { item.citiesdata && (
                        <table className="w-full mt-2">
                            <tbody>

                                <tr>
                                    <td className="search-details-item">
                                        Município(s) com passagem: {item.citiesdata.citieswithpassage?.split(',').join(', ')}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="search-details-item">
                                        Município(s) sem passagem: {item.citiesdata.citieswithoutpassages?.split(',').join(', ')}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="search-details-item">
                                        Município(s) offline: {item.citiesdata.citiesoffline?.split(',').join(', ')}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="search-details-item">
                                        Município(s) sem resposta: {item.citiesdata.citiesnoanswer?.split(',').join(', ')}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    )}

                    {item.listdownloads?.length > 0 && (
                        <>
                            <div className="mt-4 font-semibold">Exibição de imagens:</div>
                            {renderDownloads(item.listdownloads)}
                        </>
                    )}

                </td>
            </tr>
        );
    };

    return (
        <>
            {visibleColumns.length ? (
                <table id={'sentry-cloud-audit-data'} className="table report-table">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map(column => (
                                <th key={column.id}>
                                    {tableColumns?.[column.id]?.label ?? column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {data.map((element, index) => (
                            <React.Fragment key={index}>
                                <tr className={`table-break-word ${searchDetails ? 'details-row' : ''}`}>
                                    {visibleColumns.map(column => (
                                        <td key={column.id}>
                                            {column.render(element)}
                                        </td>
                                    ))}
                                </tr>

                                {renderDetails(element)}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}
        </>
    );
};

export default ReportContent;